import {Entity} from 'app/core/main.entity';
import {CustomDate} from '../core/classes/customDate';
import {ShiftState} from './enums';
import {ShiftItem} from './shiftItem.entity';
import {Transform, Type} from 'class-transformer';
import {Location} from './location.entity';
import 'reflect-metadata';
import {ShiftSettings} from './shiftSettings.entity';

export class Shift extends Entity {
  id?: number = null;
  comment: string = null;
  isEditable = false;

  @Type(() => CustomDate)
  @Transform(({value}) => value ? new CustomDate(value) : null)
  startDate: CustomDate = null;

  state?: ShiftState = null;

  @Type(() => ShiftItem)
  shifts: ShiftItem[] = [];

  @Type(() => Location)
  location?: Location = null;

  @Type(() => ShiftSettings)
  settings: ShiftSettings = null;

  constructor(startDate = null, settings = null, state = null, comment = null) {
    super();

    this.startDate = startDate;
    this.settings = settings;
    this.state = state;
    this.comment = comment;
  }

  getIntervalsString(): string {
    let str = '';

    for (let i = 0; i < this.shifts.length; i++) {
      str += this.shifts[i].startDate.format('HH:mm') +
        '-' + this.shifts[i].endDate.format('HH:mm') +
        ((i < this.shifts.length - 1) ? ', ' : '');
    }

    return str;
  }

  isValid() {
    // правила валидации здесь, а в валидаторах формы вызывать эту функцию

    if (this.startDate < this.settings.minDate || this.startDate > this.settings.maxDate) {
      return {type: 'dateInput', message: 'Дата вне допустимого диапазона'};
    }

    return null;
  }
}
